/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemActionPoliciesEntitySubject } from './SystemActionPoliciesEntitySubject';
import {
    SystemActionPoliciesEntitySubjectFromJSON,
    SystemActionPoliciesEntitySubjectFromJSONTyped,
    SystemActionPoliciesEntitySubjectToJSON,
    SystemActionPoliciesEntitySubjectToJSONTyped,
} from './SystemActionPoliciesEntitySubject';
import type { SystemActionPoliciesEntityType } from './SystemActionPoliciesEntityType';
import {
    SystemActionPoliciesEntityTypeFromJSON,
    SystemActionPoliciesEntityTypeFromJSONTyped,
    SystemActionPoliciesEntityTypeToJSON,
    SystemActionPoliciesEntityTypeToJSONTyped,
} from './SystemActionPoliciesEntityType';

/**
 * 
 * @export
 * @interface SystemActionPoliciesEntity
 */
export interface SystemActionPoliciesEntity {
    /**
     * 
     * @type {SystemActionPoliciesEntitySubject}
     * @memberof SystemActionPoliciesEntity
     */
    subject: SystemActionPoliciesEntitySubject;
    /**
     * 
     * @type {SystemActionPoliciesEntityType}
     * @memberof SystemActionPoliciesEntity
     */
    type: SystemActionPoliciesEntityType;
}

/**
 * Check if a given object implements the SystemActionPoliciesEntity interface.
 */
export function instanceOfSystemActionPoliciesEntity(value: object): value is SystemActionPoliciesEntity {
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function SystemActionPoliciesEntityFromJSON(json: any): SystemActionPoliciesEntity {
    return SystemActionPoliciesEntityFromJSONTyped(json, false);
}

export function SystemActionPoliciesEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemActionPoliciesEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'subject': SystemActionPoliciesEntitySubjectFromJSON(json['subject']),
        'type': SystemActionPoliciesEntityTypeFromJSON(json['type']),
    };
}

export function SystemActionPoliciesEntityToJSON(json: any): SystemActionPoliciesEntity {
    return SystemActionPoliciesEntityToJSONTyped(json, false);
}

export function SystemActionPoliciesEntityToJSONTyped(value?: SystemActionPoliciesEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subject': SystemActionPoliciesEntitySubjectToJSON(value['subject']),
        'type': SystemActionPoliciesEntityTypeToJSON(value['type']),
    };
}

